// extracted by mini-css-extract-plugin
export var footer = "_me-5";
export var fulfillmentInput = "_me-0";
export var shipDateInput = "_me-1";
export var shipmentModal = "_me-2";
export var shipmentModalContent = "_me-3";
export var tableContainer = "_me-4";